<p i18n class="header-text">Облицовка на новом материале</p>
<mat-nav-list>
  <mat-list-item>
    <div i18n class="text-left" matLine (click)="bottomSheetRef.dismiss(undefined)">Оставить без изменения</div>
  </mat-list-item>

  <mat-list-item>
    <div i18n class="text-left" matLine (click)="deleteButts()">Удалить облицовку</div>
  </mat-list-item>

  <mat-list-item>
    <div i18n class="text-left" matLine (click)="openButtReplacementCustomDialog()">Заменить облицовку</div>
  </mat-list-item>
</mat-nav-list>
